<div class="grid overflow-x-hidden" style="grid-template-columns: 1fr 3.5rem">
  <div>
    <button
      type="button"
      (click)="closeSidebar()"
      class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-4 mt-4 inline-flex justify-center items-center cursor-pointer"
      appAgentAction
      agent="sidebar-close"
      businessObject="sidebar"
      [businessId]="editComponentId"
      action="close"
    >
      <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
      <span class="sr-only">Close sidebar</span>
    </button>
    <div class="absolute top-0 flex items-center justify-between w-full border-b border-gray-200 -z-10 h-16 pe-16">
      <h2 class="text-sm lg:text-xl text-amazone-orange ms-16">
        <strong>{{ sidebarConfiguration?.innerSidebarTitle ? sidebarConfiguration?.innerSidebarTitle : '' }}</strong> -
        {{ sideBarTitle }}
      </h2>
    </div>
    <div class="px-6 pt-2 h-[calc(100vh-8rem)] mt-4 overflow-y-auto">
      @if (sidebarConfiguration?.isAreaEnabled(sidebarArea.auditLog)) {
        <div class="min-h-96">
          <app-timeline-overview [auditLogQuery]="auditLogQuery"></app-timeline-overview>
        </div>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.edit)) {
        @if (editComponentType && editComponentType === editComponent.Dtc) {
          <app-dtc-edit [item]="dtc" (dtcUpdated)="onUpdatedDtc($event)"></app-dtc-edit>
        } @else if (editComponentType && editComponentType === editComponent.ErrorMessage) {
          <app-edit-error-message
            [item]="errorMessage"
            (errorMessageUpdated)="onUpdatedErrorMessage($event)"
          ></app-edit-error-message>
        } @else if (editComponentType && editComponentType === editComponent.ErrorCode) {
          <app-edit-error-code [item]="errorCode" (errorCodeUpdated)="onUpdatedErrorCode($event)"></app-edit-error-code>
        } @else if (editComponentType && editComponentType === editComponent.SwPartNumber) {
          <app-edit-sw-part-number
            [swPartNumber]="swPartNumber"
            (updatedSwPartNumber)="onUpdatedSwPartNumber($event)"
          ></app-edit-sw-part-number>
        } @else if (editComponentType && editComponentType === editComponent.Project) {
          <app-edit-project [project]="project" (updatedProject)="onUpdatedProject($event)"></app-edit-project>
        } @else if (editComponentType && editComponentType === editComponent.NwNumber) {
          <app-edit-nw-number
            [item]="nwNumber"
            [nwNumber]="nwNumber"
            (updatedNwNumber)="onUpdatedNwNumber($event)"
          ></app-edit-nw-number>
        }
      } @else if (
        sidebarConfiguration?.isAreaEnabled(sidebarArea.summary) && sidebarConfiguration?.summaryAreaEnabled
      ) {
        <app-entity-details-view [detailsViewConfig]="detailsViewConfig"></app-entity-details-view>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.translations)) {
        <app-translation-state [translationStates]="languageTranslationStates"></app-translation-state>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.detailedTranslations)) {
        <app-detailed-translation-state
          [translationStatesDocumentation]="detailedLanguageTranslationStatesDocumentation"
          [translationStatesTerminal]="detailedLanguageTranslationStatesTerminal"
        ></app-detailed-translation-state>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.link)) {
        <div class="@container min-h-96">
          <app-dtc-selection-overview
            [errorMessageId]="$safeNavigationMigration(errorMessage?.id)"
            (selectedDtcsChanged)="onUpdatedErrorMessage()"
          ></app-dtc-selection-overview>
        </div>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.languageConfiguration)) {
        <app-language-configuration [nwNumberErrorMemory]="nwNumberErrorMemory"></app-language-configuration>
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.review)) {
        @if (editComponentType && editComponentType === editComponent.Dtc) {
          <app-review-request-edit
            [reviewable]="dtc"
            (reviewableUpdated)="onUpdatedDtc($event)"
          ></app-review-request-edit>
        } @else if (editComponentType && editComponentType === editComponent.ErrorCode) {
          <app-review-request-edit
            [reviewable]="errorCode"
            (reviewableUpdated)="onUpdatedErrorCode($event)"
          ></app-review-request-edit>
        }
      } @else if (sidebarConfiguration?.isAreaEnabled(sidebarArea.mergeReview)) {
        @if (editComponentType && editComponentType === editComponent.Dtc) {
          <app-review-request-merge
            [reviewable]="dtc"
            [swPartNumber]="$safeNavigationMigration(dtc?.swPartNumber)"
            (reviewableUpdated)="onUpdatedDtc($event)"
          ></app-review-request-merge>
        } @else if (editComponentType && editComponentType === editComponent.ErrorCode) {
          <app-review-request-merge
            [reviewable]="errorCode"
            [swPartNumber]="undefined"
            (reviewableUpdated)="onUpdatedErrorCode($event)"
          ></app-review-request-merge>
        }
      }
    </div>
  </div>
  <div class="h-full lg:block overflow-y-auto bg-amazone-green w-14">
    <div class="w-14 h-16 bg-amazone-orange fixed top-1 hidden xl:block"></div>
    <nav class="mt-8">
      <ul role="list" class="flex flex-col items-center space-y-1">
        @if (sidebarConfiguration?.summaryAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openDetails()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.summary)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.summary),
              }"
              appAgentAction
              agent="sidebar-open-details"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-details-icon></app-details-icon>
              <span class="sr-only">Details</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.auditLogAreaEnabled) {
          <li>
            <button
              [appEnabledByPolicy]="policy.canReadHistory"
              (click)="sidebarConfiguration?.openAuditLogs()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.auditLog)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.auditLog),
              }"
              appAgentAction
              agent="sidebar-open-audit-log"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-audit-icon></app-audit-icon>
              <span class="sr-only">Audit</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.editAreaEnabled) {
          <li>
            <button
              [appEnabledByPolicy]="policy.canUpdateInternalNotes"
              (click)="sidebarConfiguration?.openEdit()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(sidebarConfiguration?.isAreaEnabled(sidebarArea.edit)),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.edit),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-edit"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-edit></app-edit>
              <span class="sr-only">Edit</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.linkAreaEnabled) {
          <li>
            <button
              [appEnabledByPolicy]="policy.canUpdateBasic"
              (click)="sidebarConfiguration?.openLink()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(sidebarConfiguration?.isAreaEnabled(sidebarArea.link)),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.link),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-link"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-link-icon></app-link-icon>
              <span class="sr-only">Link</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.translationsAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openTranslations()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.translations)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.translations),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-translations"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-language-icon></app-language-icon>
              <span class="sr-only">Translations</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.detailedTranslationsAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openDetailedTranslations()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.detailedTranslations)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.detailedTranslations),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-detailed-translations"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-language-icon></app-language-icon>
              <span class="sr-only">Translations</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.translationsSettingsAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openLanguageConfiguration()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.languageConfiguration)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.languageConfiguration),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-language-configuration"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-language-configuration-icon></app-language-configuration-icon>
              <span class="sr-only">Language Configuration</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.reviewAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openDtcReview()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(sidebarConfiguration?.isAreaEnabled(sidebarArea.review)),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.review),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-review"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-hand-raised-icon></app-hand-raised-icon>
              <span class="sr-only">Review</span>
            </button>
          </li>
        }
        @if (sidebarConfiguration?.mergeReviewAreaEnabled) {
          <li>
            <button
              (click)="sidebarConfiguration?.openDtcReviewMerge()"
              [ngClass]="{
                'sidebar-btn-active': $safeNavigationMigration(
                  sidebarConfiguration?.isAreaEnabled(sidebarArea.mergeReview)
                ),
                'sidebar-btn': !sidebarConfiguration?.isAreaEnabled(sidebarArea.mergeReview),
              }"
              class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold hover:text-amazone-orange-light cursor-pointer disabled:cursor-not-allowed disabled:text-gray-300"
              appAgentAction
              agent="sidebar-open-merge-review"
              businessObject="sidebar"
              [businessId]="editComponentId"
              action="open"
            >
              <app-merge-icon></app-merge-icon>
              <span class="sr-only">Merge Review(s)</span>
            </button>
          </li>
        }
      </ul>
    </nav>
  </div>
</div>
